/**
 * QUÉ QUEDA EN LA CAJA AL PULSAR UNA PLANTILLA DE FEEDBACK (12-10).
 *
 * Las plantillas no pisan lo que el entrenador lleva escrito: se añaden debajo. Pero dos
 * plantillas son dos veredictos distintos ("va bien, se sigue" y "toca subir hidratos"), y
 * pulsar una después de otra dejaba las dos, contradiciéndose. Una plantilla sustituye a la
 * plantilla anterior; lo escrito a mano se queda donde estaba.
 *
 * Puro: recibe el texto actual, la plantilla elegida y la lista de textos de plantilla.
 */
export function conPlantilla(actual, texto, plantillas = []) {
    let propio = String(actual || '');
    plantillas.forEach((t) => { if (t) propio = propio.split(t).join(''); });
    propio = propio.replace(/\n{3,}/g, '\n\n').trim();
    return propio ? `${propio}\n\n${texto}` : texto;
}
